import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconUserGroup } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/registration',
  redirect: '/registration/list',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '报名管理',
    icon: IconUserGroup,
    order: 3,
    hideChildrenInMenu: true,
    roles: ['admin'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/registration/index.vue'),
      meta: {},
    },
    {
      path: 'detail/:id',
      component: () => import('@/views/registration/detail.vue'),
      props: true,
      meta: {
        title: '报名详情',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
  ],
};

export default routes;
